import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { weeksService } from '@/services/weeks.service';
import { LoadingSpinner } from '@/components/LoadingSpinner';

/**
 * Корневой маршрут: при активной неделе открываем трекер, иначе список недель.
 */
export const HomeRedirect: React.FC = () => {
  const [target, setTarget] = useState<'tracker' | 'weeks' | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const week = await weeksService.getCurrent();
        if (!cancelled) {
          setTarget(week ? 'tracker' : 'weeks');
        }
      } catch {
        if (!cancelled) {
          setTarget('weeks');
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (target === null) {
    return (
      <div
        className="container flex max-w-3xl items-center justify-center px-4 py-24"
        data-testid="home-redirect-loading"
      >
        <LoadingSpinner />
      </div>
    );
  }

  if (target === 'tracker') {
    return <Navigate to="/tracker" replace />;
  }

  return <Navigate to="/weeks" replace />;
};
